
import axios from 'axios'

let CancelToken = axios.CancelToken
export var cancelSource = null

export async function post (url, params, token) {
  cancelSource = CancelToken.source()
  let config = {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 15000,
    cancelToken: cancelSource.token
  }
  if ( token ) {
    config.headers.Authorization = 'Bearer ' + token
  }

  let data = new FormData()
  for (let field in params) {
    if (params.hasOwnProperty(field))
      data.append(field, params[field])
  }

  try {
    let response = await axios.post(url, data, config)
    if (response.status === 200) {
      cancelSource = null
      return response.data
    } else {
      // console.error('INFO','userService.post', url, response.status, response.data)
      cancelSource = null
      if (response.data && response.data.errors)
        throw new Error(response.data.errors.join(','))
      else
        throw new Error('Wrong answer for POST: ' + url + ' status: ' + response.status)
    }
  } catch (error) {
    cancelSource = null
    if (axios.isCancel(error)){
      console.log('Request cancelled', error.message)
      throw new Error('isCancelled ' + error.message)
    }

    if (error.response && error.response.data && error.response.data.errors) {
      throw new Error(error.response.data.errors.join(','))
    } else {
      throw error
    }
  }
}

export async function get (url, params = {}, token = null) {
  cancelSource = CancelToken.source()
  let config = {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    },
    timeout: 15000,
    cancelToken: cancelSource.token
  }
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }

  if (Object.keys(params).length) {
    url += '?' + Object.keys(params).map(key => { return key + '=' + encodeURIComponent(params[key]) }).join('&')
  }

  try {
    let response = await axios.get(url, config)
    if (response.status === 200) {
      cancelSource = null
      return response.data
    } else {
      // console.error('INFO', 'userService.get', url, response.status, response.data, response)
      cancelSource = null
      if (response.data && response.data.errors)
        throw new Error(response.data.errors.join(','))
      else
        throw new Error('Wrong answer for GET: ' + url + ' status: ' + response.status)
    }
  } catch (error) {
    cancelSource = null
    if (axios.isCancel(error)){
      console.log('Request cancelled', error.message)
      throw new Error('isCancelled ' + error.message)
    }
    if (error.response && error.response.data && error.response.data.errors) {
      throw new Error(error.response.data.errors.join(','))
    } else {
      throw error
    }
  }
}
